import { Component, OnInit } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SegmentosService } from '../../_services/segmentos.service';
import { Segmento } from '../../_models/segmento';
import { forkJoin } from 'rxjs';
import { SegmentoActividadesService } from '../../_services/segmento-actividades.service';
import { SegmentoProductosService } from '../../_services/segmento-productos.service';
import { SegmentoActividad } from '../../_models/segmento-actividad';
import { SegmentoProducto } from '../../_models/segmento-producto';
import { SegmentoTipoVinculacionService } from '../../_services/segmento-tipo-vinculacion.service';
import { SegmentoTipoVinculacion } from '../../_models/segmento-tipo-vinculacion';
import { SafeResourceUrl } from '@angular/platform-browser';
import { SegmentoAdjuntoService } from '../../_services/segmento-adjunto.service';
import { AdjuntoService } from '../../_services/adjunto.service';
import { SegmentoAdjunto } from '../../_models/segmento-adjunto';
import {SegmentosOcupaciones} from '../../_models/segmentos-ocupaciones';
import {SegmentosOcupacionesService} from '../../_services/segmentos-ocupaciones.service';
import {ConstanteService} from "../../_services/constante.service";

@Component( {
  templateUrl: 'segmento-detalle.component.html',
  selector: 'app-segmentos-detalle'
} )
export class SegmentoDetalleComponent implements OnInit {

  segmento: Segmento;
  segmentoActividades: SegmentoActividad[];
  segmentoProductos: SegmentoProducto[];
  segTipoVinculacion: SegmentoTipoVinculacion[] = [];
  columnasActividades: any[];
  columnasProductos: any[];
  colTipoVinculacion: any[] = [];
  cargando: boolean;
  carImagen = false;
  imagen: SafeResourceUrl;
  listaSegmentoOcupaciones: SegmentosOcupaciones[] = [];
  columnasOcupaciones: any[];
  constanteNIVEND: any;
  constructor( private navServicio: NavService,
               private router: Router,
               private route: ActivatedRoute,
               private segmentosServicios: SegmentosService,
               private segmentoActividadesService: SegmentoActividadesService,
               private segTipoVinculacionServicio: SegmentoTipoVinculacionService,
               private segAdjuntoService: SegmentoAdjuntoService,
               private adjService: AdjuntoService,
               private segmentoProductosService: SegmentoProductosService,
               private segmentosOcupaciones: SegmentosOcupacionesService,
               private conConstanteServicio: ConstanteService ) {
  }

  ngOnInit(): void {
    this.cargando = true;
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        forkJoin( this.segmentosServicios.obtener( params[ 'id' ] ),
          this.segmentoActividadesService.obtenerPorSegmento( params[ 'id' ] ),
          this.segmentoProductosService.obtenerPorSegmento( params[ 'id' ] ),
          this.segTipoVinculacionServicio.listadoPorSegmentoHabilitado( params[ 'id' ] ),
          this.segAdjuntoService.obtenerPorIdSegmento( params[ 'id' ] ),
          this.segmentosOcupaciones.listaxIdSegmento( params[ 'id' ]),
          this.conConstanteServicio.getByCode('NIVEND')).subscribe( ( [ res1, res2, res3, lisVinculaciones, adjunto , listaSegmentosOcupaciones, contNivend] ) => {
          this.constanteNIVEND = contNivend;
          this.segmento = res1;
          this.segmentoActividades = res2.filter( sa => sa.indicadorHabilitado );
          this.segmentoProductos = res3.filter( sp => sp.indicadorHabilitado );
          this.segTipoVinculacion = lisVinculaciones;
          this.listaSegmentoOcupaciones = listaSegmentosOcupaciones;
          if ( adjunto && adjunto.indicadorHabilitado ) {
            this.cargarAdjunto( adjunto.idAdjunto );
          }
          this.cargando = false;
        }, err => {
          this.navServicio.setMesage( 4, { severity: 'error', summary: 'Error', detail: 'Error al cargar / Intente nuevamente.' } );
        } );
      } else {
        this.navServicio.setMesage( 4, { severity: 'error', summary: 'Error', detail: 'Error al cargar / Intente nuevamente.' } );
      }
    } );
    this.columnasActividades = [
      { field: 'actividad', header: this.navServicio.buscarMensaje( 'SEGMENTOSACTIVIDADES.LBL_ACTIVIDADESSELECCIONADAS' ), sort: true }
    ];

    this.columnasOcupaciones = [
      { field: 'ocupacion', header: this.navServicio.buscarMensaje( 'SEGMENTOSOCUPACIONES.LBL_OCUPACIONES' ), sort: true }
    ];
    this.columnasProductos = [
      { field: 'producto', header: this.navServicio.buscarMensaje( 'SEGMENTOSPRODUCTOS.LBL_PRODUCTOSSELECCIONADOS' ), sort: true },
      { field: 'tipoProductoBancario', header: this.navServicio.buscarMensaje('PRODUCTO.LBL_TIPOPRODUCTO'), sort: true },
    ];
    this.colTipoVinculacion = [
      { field: 'tipoVinculacion', header: this.navServicio.buscarMensaje( 'SEGMENTOTIPOVINCULACION.LBL_TIPOVINCULACION' ), sort: false }
    ];
  }

  cargarAdjunto( idAdjunto: string ) {
    this.carImagen = true;
    this.adjService.descargarArchivo( idAdjunto ).subscribe( adjunto => {
      this.cargarReaderImagen( adjunto );
      this.carImagen = false;
    }, error => {
      this.carImagen = false;
    } );
  }

  cargarReaderImagen( file: any ) {
    const reader = new FileReader();
    reader.addEventListener( 'load', () => {
      this.imagen = reader.result;
    }, false );
    if ( file ) {
      reader.readAsDataURL( file );
    }
  }

  goBack() {
    this.router.navigate( [ 'apl/segmentos' ] );
  }
}
